/**
 * Localization strings used for reports and labels
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const reportsText = createDictionary({
  label: {
    'en-us': 'Label',
    'ru-ru': 'Этикетка',
    'es-es': 'Etiqueta',
    'fr-fr': 'Étiquette',
    'uk-ua': 'Етикетка',
    'de-ch': 'Etikett',
    'pt-br': 'Rótulo',
    'hr-hr': 'Označiti',
    nb: 'Etikett',
  },
  labels: {
    'en-us': 'Labels',
    'ru-ru': 'Этикетки',
    'es-es': 'Etiquetas',
    'fr-fr': 'Étiquettes',
    'uk-ua': 'Етикетки',
    'de-ch': 'Etiketten',
    'pt-br': 'Etiquetas',
    'hr-hr': 'Oznake',
    nb: 'Etiketter',
  },
  report: {
    'en-us': 'Report',
    'ru-ru': 'Отчет',
    'es-es': 'Informe',
    'fr-fr': 'Rapport',
    'uk-ua': 'Звіт',
    'de-ch': 'Auswertung',
    'pt-br': 'Relatório',
    'hr-hr': 'Izvješće',
    nb: 'Rapporter',
  },
  reports: {
    'en-us': 'Reports',
    'ru-ru': 'Отчеты',
    'es-es': 'Informes',
    'fr-fr': 'Rapports',
    'uk-ua': 'Звіти',
    'de-ch': 'Berichte',
    'pt-br': 'Relatórios',
    'hr-hr': 'Izvješća',
    nb: 'Rapporter',
  },
  reportProblems: {
    'en-us': 'Problems with report',
    'ru-ru': 'Проблемы с отчетом',
    'es-es': 'Problemas con el informe',
    'fr-fr': 'Problèmes avec le rapport',
    'uk-ua': 'Проблеми зі звітом',
    'de-ch': 'Probleme mit Bericht',
    'pt-br': 'Problemas com o relatório',
    'hr-hr': 'Problemi s izvješćem',
    nb: 'Problemer med rapporten',
  },
  reportProblemsDescription: {
    'en-us': 'The selected report has the following problems:',
    'ru-ru': 'В выбранном отчете есть следующие проблемы:',
    'es-es': 'El informe seleccionado tiene los siguientes problemas:',
    'fr-fr': 'Le rapport sélectionné présente les problèmes suivants :',
    'uk-ua': 'Вибраний звіт має такі проблеми:',
    'de-ch': 'Der ausgewählte Bericht hat folgende Probleme:',
    'pt-br': 'O relatório selecionado apresenta os seguintes problemas:',
    'hr-hr': 'Odabrano izvješće ima sljedeće probleme:',
    nb: 'Den valgte rapporten har følgende problemer:',
  },
  missingAttachments: {
    'en-us': 'Missing attachments',
    'ru-ru': 'Отсутствующие вложения',
    'es-es': 'Adjuntos ausentes',
    'fr-fr': 'Pièces jointes manquantes',
    'uk-ua': 'Відсутні вкладення',
    'de-ch': 'Fehlende Anhänge',
    'pt-br': 'Anexos ausentes',
    'hr-hr': 'Nedostaju prilozi',
    nb: 'Mangler vedlegg',
  },
  fix: {
    'en-us': 'Fix',
    'ru-ru': 'Исправить',
    'es-es': 'Reparar',
    'fr-fr': 'Corriger',
    'uk-ua': 'Виправити',
    'de-ch': 'Korrektur',
    'pt-br': 'Consertar',
    'hr-hr': 'Popraviti',
    nb: 'Fastsett',
  },
  chooseFile: {
    'en-us': 'Choose file',
    'ru-ru': 'Выберите файл',
    'es-es': 'Elejir archivo',
    'fr-fr': 'Sélectionner un fichier',
    'uk-ua': 'Виберіть файл',
    'de-ch': 'Datei auswählen',
    'pt-br': 'Selecione o arquivo',
    'hr-hr': 'Odaberite datoteku',
    nb: 'Velg fil',
  },
  reportParameters: {
    'en-us': 'Report Parameters',
    'ru-ru': 'Параметры отчета',
    'es-es': 'Parámetros del informe',
    'fr-fr': 'Paramètres du rapport',
    'uk-ua': 'Параметри звіту',
    'de-ch': 'Parameter des Berichts',
    'pt-br': 'Parâmetros do relatório',
    'hr-hr': 'Parametri izvješća',
    nb: 'Rapportparametere',
  },
  runReport: {
    'en-us': 'Run Report',
    'ru-ru': 'Запустить репорт',
    'es-es': 'Ejecutar el Informe',
    'fr-fr': 'Effectuer le rapport',
    'uk-ua': 'Запустити звіт',
    'de-ch': 'Bericht ausführen',
    'pt-br': 'Executar relatório',
    'hr-hr': 'Pokreni izvješće',
    nb: 'Kjør rapport',
  },
  missingReportQuery: {
    'en-us': 'Missing Report Query',
    'ru-ru': 'Отсутствует запрос отчета',
    'es-es': 'Consulta de informe ausente',
    'fr-fr': 'Requête de rapport manquante',
    'uk-ua': 'Відсутній запит звіту',
    'de-ch': 'Fehlende Berichtsabfrage',
    'pt-br': 'Consulta de relatório ausente',
    'hr-hr': 'Nedostaje upit izvješća',
    nb: 'Manglende rapportforespørsel',
  },
  missingReportQueryDescription: {
    'en-us': 'This report does not have an associated query',
    'ru-ru': 'Этот отчет не имеет связанного запроса',
    'es-es': 'Este informe no tiene una consulta asociada',
    'fr-fr': "Ce rapport n'a pas de requête associée",
    'uk-ua': 'Цей звіт не має прив’язаного запиту',
    'de-ch': 'Dieser Bericht hat keine zugehörige Abfrage',
    'pt-br': 'Este relatório não possui uma consulta associada.',
    'hr-hr': 'Ovo izvješće nema pridruženi upit',
    nb: 'Denne rapporten har ingen tilknyttet spørring',
  },
  missingReport: {
    'en-us': 'Missing report',
    'ru-ru': 'Отсутствует отчет',
    'es-es': 'Informe ausente',
    'fr-fr': 'Rapport manquant',
    'uk-ua': 'Відсутній звіт',
    'de-ch': 'Fehlender Bericht',
    'pt-br': 'Relatório desaparecido',
    'hr-hr': 'Nedostaje izvješće',
    nb: 'Manglende rapport',
  },
  missingReportDescription: {
    'en-us': 'Unable to find an SpReport record for this App Resource',
    'ru-ru': 'Не удалось найти запись SpReport для этого ресурса приложения',
    'es-es':
      'No se puede encontrar un registro SpReport para este recurso de aplicación',
    'fr-fr':
      "Impossible de trouver un enregistrement SpReport pour cette ressource d'application",
    'uk-ua':
      'Не вдалося знайти запис таблиці SpReport для цього ресурсу програми',
    'de-ch': 'Es kann kein SpReport für diese App-Ressource gefunden werden',
    'pt-br':
      'Não foi possível encontrar um registro SpReport para este recurso do aplicativo.',
    'hr-hr': 'Nije moguće pronaći SpReport zapis za ovaj resurs aplikacije',
    nb: 'Finner ikke en SpReport-oppføring for denne appressursen',
  },
  generateLabel: {
    'en-us': 'Generate label',
    'ru-ru': 'Сгенерировать метку',
    'es-es': 'Generar etiqueta',
    'fr-fr': 'Générer une étiquette',
    'uk-ua': 'Створити етикетку',
    'de-ch': 'Etikett generieren',
    'pt-br': 'Gerar etiqueta',
    'hr-hr': 'Generiraj oznaku',
    nb: 'Generer etikett',
  },
  generateLabelOnSave: {
    'en-us': 'Generate label on save',
    'ru-ru': 'Генерировать метку при сохранении',
    'es-es': 'Generar etiqueta al guardar',
    'fr-fr': "Générer une étiquette lors de l'enregistrement",
    'uk-ua': 'Створити етикетку під час збереження',
    'de-ch': 'Etikett beim Speichern generieren',
    'pt-br': 'Gerar etiqueta ao salvar',
    'hr-hr': 'Generiraj oznaku prilikom spremanja',
    nb: 'Generer etikett ved lagring',
  },
  generateReport: {
    'en-us': 'Generate report',
    'ru-ru': 'Сгенерировать отчет',
    'es-es': 'Generar informe',
    'fr-fr': 'Générer un rapport',
    'uk-ua': 'Створити звіт',
    'de-ch': 'Bericht generieren',
    'pt-br': 'Gerar relatório',
    'hr-hr': 'Generiraj izvješće',
    nb: 'Generer rapport',
  },
  generateReportOnSave: {
    'en-us': 'Generate report on save',
    'ru-ru': 'Генерировать отчет при сохранении',
    'es-es': 'Generar informe al guardar',
    'fr-fr': "Générer un rapport lors de l'enregistrement",
    'uk-ua': 'Створити звіт при збереженні',
    'de-ch': 'Bericht beim Speichern generieren',
    'pt-br': 'Gerar relatório ao salvar',
    'hr-hr': 'Generiraj izvješće o spremanju',
    nb: 'Generer rapport ved lagring',
  },
} as const);
